export const hotelRegions: { [key: string]: string } = {
  AFR: 'Africa',
  ASIA: 'Asia',
  EURO: 'Europe',
  MEAST: 'Middle East',
  NAME: 'North America',
  LAMECA: 'Latin America and the Caribbean',
  OCEA: 'Oceania',
}
